import { ActivatedRouteSnapshot, ActivatedRoute } from "@angular/router";

export function extractValueFromParams(route: ActivatedRouteSnapshot, name: string): string | null {
  while (true) {
    if (route == null) return null;
    const value = route.params[name];
    if (value !== undefined) {
      return value;
    }
    route = route.parent;
  }
}

export function getActivatedRoute(activatedRoute: ActivatedRoute) : ActivatedRoute {
  let route = activatedRoute;

  while (route.firstChild) {route = route.firstChild}

  return route;
}

export function getParentRoute(url: string): string {
  const segments = url.split('/');
  segments.pop();
  const result = segments.join('/');
  return result;
}

export function getParentRoutePath(route: ActivatedRouteSnapshot): string {
  return getRouteSegment(route.parent);
}

export function getParentRouteWithDataProperty(route: ActivatedRouteSnapshot, name: string): ActivatedRouteSnapshot {
  while (true) {
    if (route == null) return null;
    const value = route.data[name];
    if (value !== undefined) {
      return route;
    }
    route = route.parent;
  }
}

export function getRouteSegment(route: ActivatedRouteSnapshot): string | null {
  if (route != null
    && route.url != null
    && route.url.length > 0) {
    return route.url[0].path
  }
  return null;
}

export function getLastSegment(url: string): string {
  const segments = getUrlPath(url).split('/');
  let result = segments.pop();

  return result;
}

export function getUrlPath(url: string): string {
  if (url == null) return url;

  const queryParamIndex = url.indexOf('?');
  const result = queryParamIndex > 0 ? url.substring(0, queryParamIndex) : url;
  return result;
}
